





import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import WordCard from './WordCard.vue';
import { DictionaryEntry, DictionaryCategories, dictionary } from '@/dictionary';

@Component({ components: { WordCard } })
export default class WordDialogComponent extends Vue {

    @Prop({ required: true })
    private word!: DictionaryEntry;

    get isOverlayDialog() {
        return false;    
    }

    get dialogOpen() : boolean {
        return this.$route.hash == `#${this.word.id}`;
    }

    set dialogOpen(value: boolean) {
        if (value) {
            this.$router.push({ hash: this.word.id });
        } else {
            this.$router.go(-1);
        }
    }

}
